import React, {useEffect, useState,memo} from 'react';
import {Head, Loading} from "../../components";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { UserAutocomplete} from './../../components'
import {useDispatch, useSelector} from "react-redux";
import {requests} from "../../actions";
import {Link, useLocation, useNavigate} from "react-router-dom";
import Api from "../../utils/api";
import RequestResolve from "./resolve";
import RequestExcelDownload from "./excel";
import queryString from 'query-string';

const MarketerRequest = ( props ) => {


    const location = useLocation();
    const history = useNavigate();

    const dispatch = useDispatch();
    const  AppState  = useSelector(state => state);

    const [searchTime, setSearchTime] = useState("");
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);


    useEffect(() => {
        new Api().get('/requests/categories').then((response) => {
            if (typeof response !== "undefined") {
                setCategories(response);
            }
        })
    }, []);

    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {
            _makeQueryStringParams(event.target.name, event.target.value)

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(()=>{

                _makeQueryStringParams(name, word)

            },500);

            setSearchTime(loop);
        }


    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {
        _makeQueryStringParams(name, value)
    }

    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        status:query.status && !isNaN(query.status) ? parseInt(query.status) : -1,
        category_id:query.category_id && !isNaN(query.category_id) ? parseInt(query.category_id) : -1,
        marketer_id: query.marketer_id ? parseInt(query.marketer_id) : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
    });


    useEffect(() => {
        if (AppState.requests.ready !== 'success') {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [AppState.requests.ready]);

    const handleRequest = () => {
        dispatch(requests({
            page: params.page,
            limit: params.limit,
            status: params.status,
            category_id: params.category_id,
            marketer_id: params.marketer_id,
            name: params.name,
            username: params.username,
            national_code: params.national_code,
            mobile: params.mobile,
        }));
    }

    useEffect(() => {

        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.page,
        params.limit,
        params.status,
        params.category_id,
        params.marketer_id,
        params.name,
        params.username,
        params.national_code,
        params.mobile,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if (n_params.page !== parseInt(query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'limit':
                    if (n_params.limit !== parseInt(query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'status':
                    if (n_params.status !== query.status) {
                        n_params.status = query.status;
                    }
                    break;
                case 'category_id':
                    if (n_params.category_id !== query.category_id) {
                        n_params.category_id = query.category_id;
                    }
                    break;
                case 'marketer_id':
                    if (n_params.marketer_id !== query.marketer_id) {
                        n_params.marketer_id = query.marketer_id;
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.page,
        query.limit,
        query.status,
        query.category_id,
        query.marketer_id,
        query.name,
        query.username,
        query.national_code,
        query.mobile,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
            case 'limit':
                n_params.limit = value;
                break;
            case 'status':
                n_params.status = value;
                break;
            case 'category_id':
                n_params.category_id = value;
                break;
            case 'marketer_id':
                n_params.marketer_id = value;
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;

        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&limit=${n_params.limit}`;
        url += `&status=${n_params.status}`;
        url += `&category_id=${n_params.category_id}`;
        url += `&marketer_id=${n_params.marketer_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&mobile=${n_params.mobile}`;


        history(`/requests/${url}`);

    };


    const pageCount = Math.ceil(parseInt(AppState.requests?.entities?.total) / parseInt(AppState.requests?.entities?.per_page));

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'درخواست ها', 'description': 'درخواست های مربوط به قطع همکاری استرداد و ....' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="موضوع"
                                    value={params.category_id}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='category_id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {categories.map((item) => {
                                        return(<MenuItem key={1} value={item.id}>{item.title}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('marketer_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت"
                                    value={params.status}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {Object.keys(AppState.requests.status).map((item) => {
                                        return(<MenuItem key={1} value={item}>{AppState.requests.status[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                            <MenuItem  value="500">500</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <RequestExcelDownload object={params} />
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>شناسه</th>
                        <th>اپراتور</th>
                        <th>بازاریاب</th>
                        <th>موضوع درخواست</th>
                        <th>تاریخ درخواست</th>
                        <th style={{ width: '20%'}}>متن درخواست</th>
                        <th>وضعیت</th>
                        <th>نتیجه درخواست</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {AppState.requests.entities.data && AppState.requests.entities.data.map((entity, index) => {
                        return(
                            <tr key={index}>
                                <td>{entity.id}</td>
                                <td>{entity.operator && (entity.operator.name && entity.operator.name + ' ' + entity.operator.family)}</td>
                                <td><Link to={'/marketer/' + entity?.created_by?.id}>{entity?.created_by && (entity.created_by.name && entity.created_by.name + ' ' + entity.created_by.family)}<br/>{entity.created_by && entity.created_by.mobile}</Link></td>
                                <td>{entity.category && entity.category.title }</td>
                                <td style={{ direction: 'ltr'}}>{moment(entity.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td style={{ width: '20%', padding: '20px'}}>{entity.content}</td>
                                <td><span className={'order-status-' + entity.status}>{AppState.requests.status[entity.status]}</span></td>
                                <td>{entity.message ? entity.message : '-'}</td>
                                <td>
                                    {entity.status === 0 ? <RequestResolve onComplete={() => handleRequest()} entity={entity}/> : '-'}
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
        </div>

    );
}


export default memo(MarketerRequest);
